
export default {
  namespaced: true,  
  state: {
    code: null,
    id: null,
    message: null,
  },
  getters: {
    code: state => state.code,
    id: state => state.id,
    message: state => state.message,
  },
  mutations: {
    updateCode(state, code){
      state.code = code
    },
    updateId(state, id){
      state.id = id
    },
    updateMessage(state, message){
      state.message = message
    },
  },
  actions: {
    setError({ commit }, { code, id, message}) {
      commit('updateCode', code)
      commit('updateId', id)
      commit('updateMessage', message)
    },
    clearError({ commit }) {
      commit('updateCode', null)
      commit('updateId', null)
      commit('updateMessage', null)
    },
  },
}
